var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_15438_63390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6115 24.3216C11.615 24.3216 11.8658 24.6121 12.1314 24.9208L12.1676 24.963C12.3069 25.1249 12.4473 25.2884 12.5556 25.4146L12.5963 25.462C12.6913 25.5727 12.753 25.6447 12.7524 25.6438C6.29385 33.5345 0.106689 35.8623 0.106689 35.8623C3.32656 33.7261 7.55776 29.7203 11.6115 24.3216ZM8.23431 1.48055C11.4537 -0.742133 15.5154 0.27196 16.4239 0.573991C18.8846 1.38844 20.6175 3.10198 22.3965 6.05963C22.3897 6.07084 21.819 6.80149 21.2161 7.57283L21.139 7.67147C20.4828 8.51089 19.8152 9.3642 19.8152 9.3642C19.8044 9.35485 19.4438 8.57219 18.3048 6.82546C16.8136 4.53312 15.2807 1.78258 12.2359 2.06871C9.13858 2.35952 6.62673 7.29814 11.8401 12.6211C12.4223 13.2121 25.7685 28.4594 25.9906 28.732C26.0049 28.7159 26.2064 28.5136 26.5118 28.2079L26.5977 28.1221C26.6124 28.1074 26.6273 28.0924 26.6424 28.0773L26.9333 27.7865C28.0121 26.7084 29.6659 25.0594 29.9453 24.7808L29.9677 24.7585C29.9798 24.7464 29.9861 24.7402 29.9861 24.7402C29.3554 25.7114 28.423 27.1823 27.4774 28.6843L27.3153 28.9419C25.6122 31.649 23.9196 34.3696 23.9196 34.3696C22.7411 32.592 12.5157 21.1252 7.92914 15.5937C3.27398 9.98182 3.77213 4.55883 8.23431 1.48055ZM26.4774 12.0038C26.5215 12.059 26.5765 12.1324 26.6488 12.2222C27.8897 13.7931 33.3322 20.5182 37.5629 24.7326C41.5904 28.7432 46.3258 32.4549 49.3447 30.4674L44.328 34.2975C39.964 34.8385 30.0832 23.5436 23.9665 15.6268C23.9097 15.5567 23.8557 15.4837 23.7993 15.4145L26.4774 12.0038ZM30.151 1.4273C32.7938 -0.350288 37.087 -0.0608811 39.5707 2.67656C41.5886 4.9086 41.8867 7.70027 40.9496 10.254C40.4524 11.6029 38.8723 13.355 37.246 15.0659L37.0716 15.249C35.8505 16.5295 34.6241 17.7779 33.83 18.8067C33.83 18.8067 36.7691 13.4206 37.3081 11.205C38.4598 6.48701 35.1155 3.50878 31.4844 3.90292C29.6016 4.1077 28.319 5.6964 27.1898 6.98167C26.6388 7.61027 25.002 9.7135 23.3208 11.8754L23.1189 12.135C21.5031 14.2128 19.8847 16.2924 19.1852 17.1212L17.995 15.8327C17.9978 15.8443 24.8146 7.05834 26.2217 5.31021C27.833 3.3026 28.8349 2.31048 30.151 1.4273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_15438_63390",
    x: 0.106689,
    y: 0.0800781,
    width: 49.238,
    height: 61.7822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15438_63390"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogoWhite);
export default __webpack_public_path__ + "static/media/mobileLogoWhite.c2a721cdeca8b427523d2e164050db2e.svg";
export { ForwardRef as ReactComponent };